import * as React from 'react';
import * as styles from './grid.scss';

type Props = {
    className?: string;
}

const Grid: React.SFC<Props> = (props) => {
    return (
        <div className={styles.grid + ' clearfix' + (props.className ? ' ' + props.className : '')}>
            {props.children}
        </div>
    )
}

export default Grid;